import poll from '@/modules/common/utils/poll';
import sleep from '@/modules/common/utils/sleep';
import httpServiceV3 from '@/modules/common/services/httpServiceV3';
import { NOTE_SUMMARY_STATUS } from '@/modules/note/constants';

const MAX_POLLS = 20;
const POLL_INTERVAL_MS = 1000;
// Start polling slightly before the ETA so a ready summary is picked up without an extra interval.
const POLL_LEAD_MS = 500;

export const fetchNoteV3 = async (noteUid) => {
  const result = await httpServiceV3.get(`clients/client_notes/${noteUid}`);
  return result.data;
};

const isSummarySettled = (note) =>
  note?.summary_status !== NOTE_SUMMARY_STATUS.inProgress;

export async function pollNoteUntilSummaryReady({ noteUid, summaryExpectedAt, isCancelled }) {
  if (isCancelled?.()) return null;

  if (summaryExpectedAt) {
    const waitMs = summaryExpectedAt - Date.now() - POLL_LEAD_MS;
    if (waitMs > 0) await sleep(waitMs);
  }

  let attempts = 0;

  return poll(
    async () => {
      if (isCancelled?.()) return null;
      attempts++;
      return fetchNoteV3(noteUid);
    },
    (note) => isCancelled?.() || isSummarySettled(note) || attempts >= MAX_POLLS,
    POLL_INTERVAL_MS
  );
}
